import { NewDate, NewHour } from '@/Domain/News'
import { DanosEvitables } from './DanosEvitables'
import { DanosMadeirables } from './DanosMadeirables'
import { DanosNonMadeirables } from './DanosNonMadeirables'

export class Recognition {
    private _dataActa: NewDate | null
    private _horaActa: NewHour | null
    private _numSancionador: string
    private _observacions: string
    private _danos: boolean
    private _tipoDanos: string
    private _afeccionDanos: string
    private _danosEvitables: DanosEvitables | null
    private _danosMadeirables: DanosMadeirables | null
    private _danosNonMadeirables : DanosNonMadeirables | null

    constructor (
      dataActa: NewDate | null,
      horaActa: NewHour | null,
      numSancionador: string,
      observacions: string,
      danos: boolean,
      tipoDanos: string,
      afeccionDanos: string,
      danosEvitables: DanosEvitables | null,
      danosMadeirables: DanosMadeirables | null,
      danosNonMadeirables: DanosNonMadeirables | null
    ) {
      this._dataActa = dataActa
      this._horaActa = horaActa
      this._numSancionador = numSancionador
      this._observacions = observacions
      this._danos = danos
      this._tipoDanos = tipoDanos
      this._afeccionDanos = afeccionDanos
      this._danosEvitables = danosEvitables
      this._danosMadeirables = danosMadeirables
      this._danosNonMadeirables = danosNonMadeirables
    }

    get dataActa (): string {
      if (this._dataActa !== null) {
        return this._dataActa.date()
      } else { return '' }
    }

    get horaActa (): string {
      if (this._horaActa !== null) {
        return this._horaActa.hour()
      } else { return '' }
    }

    get numSancionador (): string {
      return this._numSancionador
    }

    get observacions (): string {
      return this._observacions
    }

    get danos (): boolean {
      return this._danos
    }

    get tipoDanos (): string {
      return this._tipoDanos
    }

    get afeccionDanos (): string {
      return this._afeccionDanos
    }

    public getDanosEvitables (): DanosEvitables | null {
      return this._danosEvitables
    }

    public getDanosMadeirables (): DanosMadeirables | null {
      return this._danosMadeirables
    }

    public getDanosNonMadeirables (): DanosNonMadeirables | null {
      return this._danosNonMadeirables
    }
}
